import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { PermissionGate } from '@saas/ui';
import { EXPENSE_ADMIN_ROLES } from './nav.js';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

function admin(load: () => Promise<PageModule>, anyOf: string[]): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    const Page = m.default;
    const Guarded = () => (
      <PermissionGate anyOf={anyOf} roles={EXPENSE_ADMIN_ROLES}>
        <Page />
      </PermissionGate>
    );
    return { Component: Guarded };
  };
}

export const expenseRoutes: RouteObject[] = [
  { path: '/expense', lazy: page(() => import('./pages/ExpenseListPage.js')) },
  { path: '/expense/new', lazy: page(() => import('./pages/ExpenseNewPage.js')) },
  { path: '/expense/requests/:id', lazy: page(() => import('./pages/ExpenseDetailPage.js')) },
  { path: '/expense/search', lazy: page(() => import('./pages/ExpenseSearchPage.js')) },
  { path: '/expense/journal-export', lazy: admin(() => import('./pages/JournalExportPage.js'), ['expense.export.execute']) },
  { path: '/expense/account-codes', lazy: admin(() => import('./pages/AccountCodesPage.js'), ['expense.account_code.manage']) },
  { path: '/expense/reports/input-deadline', lazy: admin(() => import('./pages/InputDeadlineReportPage.js'), ['expense.report.read']) },
];
